"use client"

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar"

import {
    LayoutDashboard,
    Car,
    Smartphone,
    User,
    Calendar,
    FileChartColumnIncreasing,
    SquarePercent,
    LayoutList,
    Component,
    CalendarSync,
} from "lucide-react"
import { useTranslate } from "react-admin";
import { NavLink, useLocation } from "react-router-dom";

export function TourAgent() {
    const { pathname } = useLocation()

    const translate = useTranslate();

    const data = {
        dispatch: {
            title: "Dashboard",
            navs: [
                {
                    name: "Dashboard",
                    url: "/",
                    icon: LayoutDashboard,
                },
                {
                    name: translate(`orders.name`, { smart_count: 2 }),
                    url: "/orders",
                    icon: LayoutList,
                },
                {
                    name: translate(`reservations.name`, {smart_count: 2}),
                    url: "/reservations",
                    icon: Calendar
                },
                {
                    name: translate("report.name", {smart_count: 2}),
                    url: "/reports",
                    icon: FileChartColumnIncreasing,
                }
            ]
        },
        management: {
            title: "Management",
            navs: [
                {
                    name: "Partners",
                    url: "/referral-agents",
                    icon: SquarePercent,
                },
                {
                    name: translate(`devices.name`, { smart_count: 2 }),
                    url: "/devices",
                    icon: Smartphone,
                },
                {
                    name: translate(`drivers.name`, { smart_count: 2 }),
                    url: "/drivers",
                    icon: User,
                },
                {
                    name: translate(`vehicles.name`, { smart_count: 2 }),
                    url: "/vehicles",
                    icon: Car,
                },
                {
                    name: "Tours",
                    url: "/tours",
                    icon: Component,
                },
                {
                    name: "Transfers",
                    url: "/transfers",
                    icon: CalendarSync,
                }
            ]
        }
    }

    return (
        <SidebarGroup>
            <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
            <SidebarMenu>
                {data.dispatch.navs.map((item: any) => (
                    <SidebarMenuItem key={item.name} className={`${item.url == "" + pathname ? 'bg-gray-200 dark:bg-neutral-600 rounded-lg' : ''}`}>
                        <SidebarMenuButton asChild>
                            <NavLink to={item.url} className="cursor-pointer">
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
                        </SidebarMenuButton>

                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
            <br />
            <SidebarGroupLabel className="mt-0">{data.management.title}</SidebarGroupLabel>
            <SidebarMenu>
                {data.management.navs.map((item: any) => (
                    <SidebarMenuItem key={item.name} className={`${item.url == "" + pathname ? 'bg-gray-200 dark:bg-neutral-600 rounded-lg' : ''}`}>
                        <SidebarMenuButton asChild>
                            <NavLink to={item.url} className="cursor-pointer">
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
                        </SidebarMenuButton>

                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
